export {default} from './Tag'
